function isPlainPrimaryClick(event: MouseEvent): boolean {
    if (event.defaultPrevented || event.button !== 0) {
        return false;
    }

    return !(event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}

export function usesDirectNativeAppInstall(userAgent: string, maxTouchPoints: number): boolean {
    return /Android|iPhone|iPad|iPod/i.test(userAgent) ||
        (/Macintosh/i.test(userAgent) && maxTouchPoints > 1);
}

function hasNativeAppAction(element: Element): boolean {
    const actionElement = element.closest<HTMLElement>("[data-native-action]");
    const action = actionElement?.dataset.nativeAction?.trim();
    if (!action || !nativeAppActions.has(action)) {
        return false;
    }

    const link = element.closest<HTMLAnchorElement>("a[href]");
    return !link || !/^(mailto|tel|sms):/i.test(link.protocol);
}

const nativeAppActions = new Set([
    "favorite", "favorites", "profile", "ai-guide", "offline", "offline-guide",
    "plan-tour", "plan-tour-there", "map-layers", "premium-content", "open-native-app"
]);

export function shouldInterceptNativeAppAction(element: Element, event: MouseEvent): boolean {
    if (!isPlainPrimaryClick(event)) {
        return false;
    }

    return hasNativeAppAction(element);
}

export function shouldInterceptNativeAppActionKey(element: Element, event: KeyboardEvent): boolean {
    if (event.defaultPrevented) {
        return false;
    }

    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return false;
    }

    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") {
        return false;
    }

    return hasNativeAppAction(element);
}
